import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import MediaQuery from "react-responsive";

function Menu() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header style={styles.header}>
      {/* Title */}
      <NavLink to="/" style={styles.titleLink}>
        <h1 style={styles.title}>RESUMEFUEL</h1>
      </NavLink>

      {/* Desktop Navigation */}
      <MediaQuery minWidth={769}>
        <nav style={styles.nav}>
          <NavLink to="/" style={getLinkStyle} end>Home</NavLink>
          <NavLink to="/about" style={getLinkStyle}>About</NavLink>
          <NavLink to="/pricing" style={getLinkStyle}>Pricing</NavLink>
          <NavLink to="/account" style={getLinkStyle}>Account</NavLink>
          <NavLink to="/contact" style={getLinkStyle}>Contact</NavLink>
        </nav>
      </MediaQuery>

      {/* Mobile Hamburger Menu */}
      <MediaQuery maxWidth={768}>
        <div style={styles.mobileMenu}>
          <button onClick={toggleMenu} style={styles.hamburger}>
            ☰
          </button>
          {menuOpen && (
            <div style={styles.dropdown}>
              <NavLink to="/" style={getLinkStyle} onClick={closeMenu} end>Home</NavLink>
              <NavLink to="/about" style={getLinkStyle} onClick={closeMenu}>About</NavLink>
              <NavLink to="/pricing" style={getLinkStyle} onClick={closeMenu}>Pricing</NavLink>
              <NavLink to="/account" style={getLinkStyle} onClick={closeMenu}>Account</NavLink>
              <NavLink to="/contact" style={getLinkStyle} onClick={closeMenu}>Contact</NavLink>
            </div>
          )}
        </div>
      </MediaQuery>
    </header>
  );
}

// Active link styling
const getLinkStyle = ({ isActive }) => ({
  color: isActive ? "#007bff" : "#333",
  textDecoration: "none",
  fontSize: 16,
  fontWeight: isActive ? "bold" : "normal",
  padding: "8px 0",
});

const styles = {
  header: {
    backgroundColor: "#fff",
    color: "#333",
    padding: "20px 30px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    position: "relative",
  },
  titleLink: {
    textDecoration: "none",
    color: "#333",
  },
  title: {
    margin: 0,
    fontSize: 24,
  },
  nav: {
    display: "flex",
    gap: "15px",
    alignItems: "center",
  },
  mobileMenu: {
    position: "relative",
  },
  hamburger: {
    fontSize: 24,
    background: "none",
    border: "none",
    cursor: "pointer",
    color: "#333",
  },
  dropdown: {
    position: "absolute",
    top: "50px",
    right: "0px",
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    borderRadius: "8px",
    padding: "10px 20px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    zIndex: 1000,
    width: "180px",
  },
};

export default Menu;
